import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1.6 x 0.8 stone altar on 2x1 tiles: a stone slab at
// 1.0 on a solid base, a thin gold trim line and a small cross block on top.
const STONE = "#9a9a94";
const STONE_LIGHT = "#aeaea6";
const GOLD = "#c9a24b";

export const churchAltar = defineModel({
  id: "church-altar",
  batchId: "modern",
  name: "Church altar",
  tags: ["modern", "interior", "furniture", "church", "table", "altar"],
  summary: "A stone altar table with a gold trim line and a small cross.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // solid stone base
      { geometry: new THREE.BoxGeometry(1.3, 0.86, 0.6), color: STONE, position: [0, 0.43, 0] },
      // altar slab (top surface at 1.0)
      { geometry: new THREE.BoxGeometry(1.6, 0.11, 0.8), color: STONE_LIGHT, position: [0, 0.945, 0] },
      // thin gold trim line along the slab's lower edge
      { geometry: new THREE.BoxGeometry(1.62, 0.025, 0.82), color: GOLD, position: [0, 0.9, 0] },
      // small cross block on top
      { geometry: new THREE.BoxGeometry(0.06, 0.36, 0.06), color: GOLD, position: [0, 1.18, -0.2] },
      { geometry: new THREE.BoxGeometry(0.22, 0.06, 0.06), color: GOLD, position: [0, 1.26, -0.2] },
      // cross foot
      { geometry: new THREE.BoxGeometry(0.14, 0.04, 0.1), color: STONE, position: [0, 1.02, -0.2] },
    ];
  },
  animations: [],
});
